/** Build public-site URLs independently of the app's router base. */
export function useSiteUrl() {
  const config = useRuntimeConfig()
  const origin = config.public.siteUrl || useRequestURL().origin
  return (path = '/') => new URL(path, origin).href
}
